import { combineReducers } from "redux";

import { userAgentsEntriesReducer } from "modules/UserAgents/services/UserAgents/reducer";

export const userAgentsReducer = combineReducers({ entries: userAgentsEntriesReducer });